// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3c8tg","additionalInfo":"AgreementModal_additionalInfo__NEvWj"};